<template>
    <div class="profileshow">
        <div class="row align-item-center pt-2 pb-2">
            <div class="col">
                <h2 class="ui text huge-lg big-sm large black mb-0">{{$t('Account')}}</h2>
            </div>
            <!-- <div class="col text-right"><span class="ui text huge-lg big bold color theme d-flex align-items-center ml-auto"><img class="ml-auto w-30px mr-1" src="../../assets/img/icon-coin-active.svg"> <span>500.00</span> <span class="ui text large-lg small color black pt-1">คะแนน</span></span></div> -->
        </div>
        <hr class="gray-7 mt-0">
        <div class="row align-items-end">
            <div class="col">
                <p class="ui text medium-md tiny-sm tiny light black mt-2 mb-2">{{$t('Name')}} <span class="color gray-7 d-inline-block ml-2">{{user.firstname}} {{user.lastname}}</span></p>
                <p class="ui text medium-md tiny-sm tiny light black mt-2 mb-2">{{$t('Birthday')}} <span class="color gray-7 d-inline-block ml-2">{{user.birthdate}}</span></p>
                <p class="ui text medium-md tiny-sm tiny light black mt-2 mb-2">{{$t('Sex')}} <span class="color gray-7 d-inline-block ml-2">{{user.gender}}</span></p>
                <p class="ui text medium-md tiny-sm tiny light black mt-2 mb-2">{{$t('Mobile')}} <span class="color gray-7 d-inline-block ml-2">{{user.phone}}</span></p>
                <p class="ui text medium-md tiny-sm tiny light black mt-2 mb-2">{{$t('Email')}} <span class="color gray-7 d-inline-block ml-2">{{user.email}}</span></p>
            </div>
            <div class="col-2 text-sm-right text-center px-2 px-sm-0">
                <router-link :to="'/profile/update'" :user="user" class="ui text large-lg medium-sm small p-1 mt-4 color black js-edit-address-btn d-inline-block pointer">
                    <i class="edit outline icon"></i>{{$t('Update')}}
                </router-link>
            </div>
        </div>
        <hr class="gray-7 mt-0">
        <div class="row align-item-center">
            <div class="col">
                <h2 class="ui text big-md large-sm medium bold black pt-3 pb-3 mb-0">{{$t('ShippingAddress')}}</h2>
            </div>
            <div class="col text-right pt-2">
                <router-link :to="'/profile/address'" class="ui button theme text medium shadow py-lg-2 py-1">
                    <span class="ui text medium light">{{$t('AddAddress')}}</span>
                </router-link>
            </div>
        </div>
        <div v-for="(address,i) in user.addresses" :key="address.id" class="row align-items-end">
            <div class="col">
                <p class="ui text medium-md tiny-sm tiny bold black bold mt-2 mb-2">{{address.fullname}}</p>
                <p class="ui text medium-md tiny-sm tiny light black mt-2 mb-2">
                    {{user.getAddress[i].text}}
                </p>
                <p class="ui text medium-md tiny-sm tiny light black mt-2 mb-2">{{$t('Mobile')}} {{address.phone}}</p>
            </div>
            <div class="col-2 text-sm-right text-center px-2 px-sm-0">
                <router-link :to="'/profile/address/'+ address.id" class="ui text large-lg medium-sm small p-1 mt-4 color black js-edit-address-btn d-inline-block">
                    <i class="edit outline icon"></i>{{$t('Update')}}
                </router-link> 
                <a @click="btnRemove(address.id)" class="ui text large-lg medium-sm small pointer p-1 color black js-edit-address-btn d-inline-block" data-toggle="modal" data-target="#showModalConfirm">
                    <i class="trash alternate outline icon"></i>{{$t('Delete')}}
                </a>
            </div>
        </div>
        <ConfirmPopup v-if="showModal" @close="showModal = false" :msg="popupRemoveAddress"  />
    </div>
</template>
<script>
import ConfirmPopup from '@/components/popup/Confirm'
export default {
    name: 'profileshow',
    components: {
        ConfirmPopup
    },
    props:{
        user: {
            type: Object,
            default: {}
        }
    },
    data(){
        return {
            showModal: false,
            confirmRemove: false,
            popupRemoveAddress:{
                title: 'ยืนยันทำรายการ',
                message: 'ต้องการลบที่อยู่ที่จัดส่งนี้หรือไม่'
            },
            removeId: null,
        }
    },
    created() {
    
    },
    methods:{
        btnRemove(id){
            this.removeId = id
            this.showModal = false
            this.popupModal()
        },
        popupModal(){
            this.showModal = true
        }
    },
    watch: {
        confirmRemove(val){
            if(val === true){
                this.$http.delete('address/' + this.removeId)
                .then(res => {
                    this.$parent._getProfile()
                })
                .catch(error => {
                    if(!error.response){
                        return
                    }
                    let message = error.response.data.errors.message
                    if(message != ''){
                        this.$parent.$parent.message.title = 'ลบที่อยู่ที่จัดส่ง'
                        this.$parent.$parent.message.message = message
                        this.$parent.$parent.showMessage = !this.$parent.$parent.showMessage
                    }
                })
            }
            this.showModal = false
            this.confirmRemove = false
            this.removeId = null
        }
    }
}
</script>
